module.exports = __webpack_public_path__ + "img/relation.eab48224.png";